/**
 * productClientGate — SPY-40 product menu→ARAM without ?debug=1.
 * Debug maps / tools stay optional behind the debug query.
 */

import { MP_TEST_MAP_ID, orderMapsForLobby } from '../../domain/map/mpTestDefaults.js';

export const PRODUCT_MAP_IDS = Object.freeze([MP_TEST_MAP_ID]);

export function isDebugClientSearch(search = '') {
  const q = String(search || '');
  return /(?:^\?|&)debug=1(?:&|$)/.test(q) || q === '?debug=1';
}

export function isProductClientSearch(search = '') {
  return !isDebugClientSearch(search);
}

/**
 * Product URL: ARAM only. ?debug=1: full ordered lobby map list.
 * @param {string[]} allMapIds
 * @param {string} [search]
 * @returns {string[]}
 */
export function resolveClientMaps(allMapIds = [], search = '') {
  const ids = Array.isArray(allMapIds) ? allMapIds : [];
  if (isDebugClientSearch(search)) {
    return orderMapsForLobby(ids);
  }
  return PRODUCT_MAP_IDS.filter((id) => ids.includes(id));
}
